import React from 'react';
import { Navbar, Nav, NavDropdown } from 'react-bootstrap';

function Menu() {
  const elements = [
    {
      type: 'link',
      name: 'INÍCIO',
      path: '/'
    }, 
    {
      type: 'link',
      name: 'QUEM SOMOS',
      path: '/quem-somos'
    }, 
    {
      type: 'link',
      name: 'PROJETOS',
      path: '/projetos'
    },
    {
      type: 'link',
      name: 'CONTATO',
      path: '/contato'
    },
    {
      type: 'link',
      name: 'TRANSPARÊNCIA',
      path: '/transparencia'
    },
  ];

  return (
    <>
      <Navbar.Toggle aria-controls="basic-navbar-nav" />
      <Navbar.Collapse id="basic-navbar-nav" className="menu">
        <Nav className="mx-auto">
          {elements.map((element, index) => {
            if (element.type === 'link') {
              return (<Nav.Link key={element.path} href={element.path} style={{ color: '#FFF' }}>{element.name}</Nav.Link>);
            } else if (element.type === 'dropdown') {
              return (
                <NavDropdown key={element.name} title={element.name} id="basic-nav-dropdown" className="menu">
                  {
                    element.items?.map((item) => (
                      <NavDropdown.Item key={item.path} href={item.path}>{item.name}</NavDropdown.Item>
                    ))
                  }
                </NavDropdown>
              )
            }
            return null;
          })}
        </Nav>
      </Navbar.Collapse>
    </>
  );
}

export default Menu;
